import axios, { formDataRequest } from './axios'

const url = '/facility'

export const getFacilties = () => axios.get(url)

export const facilityDetail = (facilityId) => axios.get(`${url}/${facilityId}`)

export const createFacility = (params) => axios.postJson(url, params)

export const editFacility = (params, id) =>
  axios.putJson(`${url}/${id}`, params)

export const deleteFacility = (id) => axios.delete(`${url}/${id}`)

export const removePersonFromFacility = (facilityId, personId) =>
  axios.deleteJson(`${url}/person`, {
    facility_id: facilityId,
    person_id: personId
  })

export const addPersonToFacility = (params) =>
  axios.postJson(`${url}/person`, params)

export const assignPersonToExperts = (params) =>
  axios.postJson(`${url}/assign`, params)

export const saveFacilityLogo = (file, id, query) => {
  let path = `/facility/logo/${id}`
  if (query) {
    path += query
  }
  const formData = new FormData()
  formData.append('file', file)
  return formDataRequest({
    method: 'put',
    path,
    data: formData
  })
}

export const saveFacilityBanner = (file, id) => {
  const path = `/facility/banner/${id}`
  const formData = new FormData()
  formData.append('file', file)
  return formDataRequest({
    method: 'put',
    path,
    data: formData
  })
}
